import React, { forwardRef } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Icon } from "../Icon";

import { ListConsumer } from "./ListContext";

import styles from "./List.scss";

const ListItem = forwardRef(
  ({ children, customClass, icon: customIcon, ...restProps }, ref) => {
    return (
      <ListConsumer>
        {({ icon, iconSizeStyles }) => {
          const iconToUse = customIcon || icon;

          return (
            <li
              className={cx(styles.item, customClass)}
              ref={ref}
              {...restProps}
            >
              {iconToUse ? (
                <>
                  <span className={cx(styles.icon)}>
                    <Icon
                      icon={iconToUse.icon}
                      size={customIcon?.size || iconSizeStyles}
                      color={iconToUse.color}
                      wrapperProps={iconToUse?.wrapperProps}
                    />
                  </span>
                  {children}
                </>
              ) : (
                children
              )}
            </li>
          );
        }}
      </ListConsumer>
    );
  }
);

ListItem.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  icon: PropTypes.shape({
    icon: PropTypes.elementType,
    color: PropTypes.string,
    wrapperProps: PropTypes.objectOf(PropTypes.any),
  }),
  customClass: PropTypes.string,
};

ListItem.defaultProps = {
  customClass: undefined,
  icon: null,
};

ListItem.displayName = "List.Item";

export default ListItem;
